import { Component, inject } from '@angular/core';
import { ApiUrlService, View } from '@lib/core';
import { EnvService } from '@lib/env';
import { Router } from '@angular/router';

@Component({
    selector: 'invalid-api-url',
    templateUrl: './invalid-api-url.component.html',
    styleUrls: ['./invalid-api-url.component.scss'],
    standalone: false
})
export class InvalidApiUrlComponent {
    private readonly apiUrlService = inject(ApiUrlService);
    private readonly env = inject(EnvService);
    private readonly router = inject(Router);

    public View = View;

    public changeApiUrl() {
        const currentApiUrl = this.env.apiUrl;
        this.apiUrlService.openApiUrlDialog(currentApiUrl).subscribe(async () => {
            await this.router.navigate([View.CLIENT, 'login']);
        });
    }
}
